import {
  PACKAGE_PRICING_MODEL,
  PACKAGE_TYPE,
  TInclusion,
  TSelectedHealthPackageItem,
  TSessionItem,
} from "@elixir/types";
import { convertMinutesToHours } from "./time-utils";

export const getDefaultPackage = (): TSelectedHealthPackageItem => {
  return {
    package_name: "",
    number_of_inclusions: 1,
    pricing_model: PACKAGE_PRICING_MODEL.ONE_TIME,
    total_price: 0,
    description: "",
    inclusions: [getDefaultSession()],
    package_expiry_from_start: 0,
    active: true,
    archived: false,
    max_members: 1,
    type: PACKAGE_TYPE.SUBSCRIPTION_PLAN,
    staff_modify_access: true,
  };
};

export const getDefaultSession = (currSessionNumber?: number): TInclusion => {
  return {
    inclusion_name: `Session ${currSessionNumber ? currSessionNumber + 1 : 1}`,
    inclusion_duration: 30,
    inclusion_day_from_start: 0,
    inclusion_description: "",
    inclusion_price: 0,
    inclusion_expiry_from_start: 75,
  };
};

export const formattedPackageDetails = (
  data: (TInclusion & {
    dateContent?: JSX.Element | null;
    slot?: {
      doctor_oid: string;
      start_time: string;
      end_time: string;
      clinic_id: string;
    };
  })[],
  dateContent?: (idx: number) => JSX.Element | null
): TSessionItem[] => {
  return data?.map((item, idx) => {
    return {
      date: item.slot?.start_time || "",
      description: item.inclusion_description,
      duration: item.inclusion_duration
        ? convertMinutesToHours(item.inclusion_duration)
        : "",
      name: item.inclusion_name,
      startTime: item.slot?.start_time,
      endTime: item.slot?.end_time,
      price: item.inclusion_price,
      dateContent: item.dateContent ? item.dateContent : dateContent?.(idx),
      schedule: getInclusionSchedule(item.inclusion_day_from_start),
    };
  });
};

function getInclusionSchedule(inclusion_day_from_start: number) {
  const months = inclusion_day_from_start / 30;
  const weeks = inclusion_day_from_start / 7;
  const days = inclusion_day_from_start;

  if (!inclusion_day_from_start || inclusion_day_from_start === 0) {
    return "";
  }

  if (months === Math.floor(inclusion_day_from_start / 30)) {
    return `Month ${months}`;
  } else if (weeks === Math.floor(inclusion_day_from_start / 7)) {
    return `Week ${weeks}`;
  } else if (days === Math.floor(inclusion_day_from_start)) {
    return `Day ${days}`;
  }
}

export const formatSessionsToInclusions = (
  inclusions: TSessionItem[]
): TInclusion[] => {
  return inclusions.map((session) => {
    const isMin = session.duration.toLowerCase().includes("min");
    const val = Number(session.duration.split(" ")[0]);

    let days = 0;
    if (session.schedule?.toLowerCase().includes("day")) {
      days = parseInt(session.schedule.split(" ")[1]);
    } else if (session.schedule?.toLowerCase().includes("week")) {
      days = parseInt(session.schedule.split(" ")[1]) * 7;
    } else if (session.schedule?.toLowerCase().includes("month")) {
      days = parseInt(session.schedule.split(" ")[1]) * 30;
    }

    return {
      inclusion_day_from_start: days,
      inclusion_description: session.description,
      inclusion_duration: isMin ? val : val * 60,
      inclusion_name: session.name,
      inclusion_price: session.price,
      inclusion_expiry_from_start: 0,
    };
  });
};
